<!--  -->
<template>
  <div>
    <!-- <el-select v-model="choosetypename" placeholder="请选择">
      <el-option
        v-for="item in options"
        :key="item.mini_program_type"
        :label="item.type_name"
        :value="item.mini_program_type"
      />
    </el-select> -->
    <el-table
      :data="options"
      style="width: 100%"
      border
    >
      <el-table-column
        prop="type_name"
        label="名称"
        width="180"
        align="center"
      />
      <!-- <el-table-column
        prop="index_path"
        label="路径"
        width="180"
      /> -->
      <el-table-column
        prop="index_path"
        label="操作"
        align="center"
      >
        <template slot-scope="scope">
          <el-button type="primary" @click="choice(scope.row)">选择</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- <div style="margin-top:20px">
      <el-button type="primary" size="mini" @click="chserclick">确定</el-button>
    </div> -->

  </div>

</template>

<script>
import { mptypeslist } from '@/api/sourceMaterial.js'
export default {
  components: {},
  data() {
    return {
      options: []
      // choosetypename: ''
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    send() {
      this.getapplets()
    },
    async getapplets() {
      const data = await mptypeslist()
      this.options = data.data.types
      console.log('data', data)
    },
    // chserclick() {
    //   // eslint-disable-next-line eqeqeq
    //   if (this.choosetypename == '') {
    //     this.$message.error('请选择小程序')
    //     return
    //   }
    //   this.$emit('appletupdata')
    // },
    choice(item) {
      this.$emit('appletupdata', item)
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */

</style>
